import axios from 'axios';

// Use relative URL for same-domain deployments (like Vercel)
// Use full URL only for cross-domain deployments
const API_URL = process.env.NODE_ENV === 'development' 
  ? '/api' 
  : (process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : '/api');

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

class GoogleDocsService {
  // Get Google Docs OAuth URL
  async getAuthUrl() {
    try {
      const response = await api.get('/google-docs/auth');
      return response.data.authUrl;
    } catch (error) {
      console.error('Error getting Google Docs auth URL:', error);
      throw error;
    }
  }

  // Check Google Docs connection status
  async getStatus() {
    try {
      const response = await api.get('/google-docs/status');
      return response.data.connected;
    } catch (error) {
      console.error('Error checking Google Docs status:', error);
      return false;
    }
  }

  // Disconnect Google Docs
  async disconnect() {
    try {
      const response = await api.post('/google-docs/disconnect');
      return response.data;
    } catch (error) {
      console.error('Error disconnecting Google Docs:', error);
      throw error;
    }
  }

  // Export Account Brief to Google Docs
  async exportAccountBrief(id) {
    try {
      const response = await api.post(`/google-docs/export/account-brief/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error exporting account brief to Google Docs:', error);
      throw error;
    }
  }

  // Export Battle Card to Google Docs
  async exportBattleCard(id) {
    try {
      const response = await api.post(`/google-docs/export/battle-card/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error exporting battle card to Google Docs:', error);
      throw error;
    }
  }

  // Export Objection Handling to Google Docs
  async exportObjectionHandling(id) {
    try {
      const response = await api.post(`/google-docs/export/objection-handling/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error exporting objection handling to Google Docs:', error);
      throw error;
    }
  }

  // Initiate Google Docs OAuth flow
  connect() {
    window.location.href = `${process.env.REACT_APP_API_URL}/google-docs/auth`;
  }

  // Get user's Google Docs list
  async getDocuments() {
    try {
      const response = await api.get('/google-docs/documents');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching Google Docs:', error);
      throw error;
    }
  }

  // Import Google Doc to Velox Knowledge Hub
  async importDocument(documentId) {
    try {
      const response = await api.post(`/google-docs/import/${documentId}`);
      return response.data;
    } catch (error) {
      console.error('Error importing Google Doc:', error);
      throw error;
    }
  }

  // Export Saved Notes document to Google Docs
  async exportSavedNote(documentType, documentId) {
    try {
      const response = await api.post(`/google-docs/export-saved-note/${documentType}/${documentId}`);
      return response.data;
    } catch (error) {
      console.error('Error exporting saved note to Google Docs:', error);
      throw error;
    }
  }
}

const googleDocsService = new GoogleDocsService();
export default googleDocsService; 